// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__NCfx+"};